import { ReactElement } from 'react';

import { CategoryListItemExt, PostListItem } from 'api';
import { Spinner } from 'components';
import { PostListItem as PostListI } from 'features/postsList';
import { InViewItemRef } from 'types';

import { EmptyState } from '../EmptyState';
import { ListW } from './styled';
import { spinnerSx } from './styles';

interface DocumentsListProps {
  isEmptyList: boolean;
  isLoading: boolean;
  isFetchingNextPage: boolean;
  documents: PostListItem[];
  lastItemRef: InViewItemRef;
  tag?: string;
  categoriesList: CategoryListItemExt[];
}

export function AllPostList({
  documents,
  isLoading,
  isEmptyList,
  isFetchingNextPage,
  lastItemRef,
  categoriesList,
}: DocumentsListProps): ReactElement {
  if (!isLoading && isEmptyList) {
    return <EmptyState />;
  }

  return (
    <ListW>
      <>
        {documents.map((document, idx) => (
          <PostListI
            key={document.id}
            lastItemRef={idx === documents.length - 1 ? lastItemRef : undefined}
            categoriesList={categoriesList}
            {...document}
          />
        ))}
        {isFetchingNextPage && <Spinner wrapperSx={spinnerSx} />}
      </>
    </ListW>
  );
}
